import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorHidePageInfoDirective } from './paginator-hide-page-info.directive';



@NgModule({
  declarations: [
    PaginatorHidePageInfoDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PaginatorHidePageInfoDirective
  ]
})
export class PaginatorHidePageInfoModule { }
